import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';

import isPrerender from 'Helpers/SEO/is-prerender';

function LazyLoad({ children, fallback, ...props }) {
  const { ref, inView } = useInView({ triggerOnce: true, ...props });

  return (
    <div ref={ref} className="lazy-load-wrapper">
      {inView ?
        children :
        fallback
      }
    </div>
  );
}

export default function LazyLoadCatch(props) {
  if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
    !isPrerender()) {
    return <LazyLoad {...props} />;
  }

  return props.children;
}

LazyLoadCatch.propTypes = {
  children: PropTypes.node.isRequired,
};

LazyLoad.propTypes = {
  fallback: PropTypes.node,
  children: PropTypes.node.isRequired,
};

LazyLoad.defaultProps = {
  fallback: <div className="lazy-load-fallback" />,
};
